import {
  lbPropositionApi,
  lbUserApi,
  lbApiBeta
} from '../../../utils/axiosConfig';

// A 401 is the only proof that the session is invalid. Anything else
// (network error, timeout, 429, 5xx) is transient: retry with backoff and,
// if it still fails, throw so callers can keep the current auth state
// instead of treating the user as logged out.
const FETCH_USER_RETRY_DELAYS_MS = [1000, 3000];

async function fetchUser() {
  for (let attempt = 0; ; attempt++) {
    try {
      const response = await lbUserApi.get('/user/current');
      if (response.data && response.data.userId) {
        return response.data;
      }
      return null;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return null;
      }
      if (attempt >= FETCH_USER_RETRY_DELAYS_MS.length) {
        throw error;
      }
      await new Promise(resolve =>
        setTimeout(resolve, FETCH_USER_RETRY_DELAYS_MS[attempt])
      );
    }
  }
}

export async function fetchUserPropositions() {
  try {
    const response = await lbPropositionApi.get('/propositions/user');

    if (response.data && response.data.length > 0) {
      return response.data;
    }
  } catch (error) {
    window.Logger.error(error);
  }

  return null;
}

export async function fetchPropositionTasks(propositionId) {
  try {
    const { data } = await lbApiBeta.get(
      `/api/v2/proposition/${propositionId}/tasks`
    );
    return data.tasksToComplete;
  } catch (error) {
    window.Logger.error(error);
    return null;
  }
}

// Only tasks the backend lists as client-completable (e.g.
// MATCHES_TRIANGLE_GUIDE) can be completed this way; the rest complete as a
// side effect of their own endpoints.
export async function completePropositionTask(propositionId, task) {
  try {
    await lbApiBeta.post(
      `/api/v2/proposition/${propositionId}/tasks/${task}/complete`
    );
    return true;
  } catch (error) {
    window.Logger.error(error);
    return false;
  }
}

export default {
  fetchUser,
  fetchUserPropositions,
  fetchPropositionTasks,
  completePropositionTask
};
